"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.uploadPropType = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemIcon = _interopRequireDefault(require("./ItemIcon"));

var _Item = _interopRequireDefault(require("./Item.style"));

var _UploadBar = require("../UploadBar.style");

var Item = function Item(_ref) {
  var upload = _ref.upload,
      _onClick = _ref.onClick;
  return _react.default.createElement(_Item.default, {
    success: upload.status === 'success'
  }, _react.default.createElement(_UploadBar.StyledFileName, null, upload.name), _react.default.createElement("button", {
    onClick: function onClick() {
      return _onClick(upload);
    }
  }, _react.default.createElement(_ItemIcon.default, {
    status: upload.status,
    progress: upload.progress
  })));
};

var uploadPropType = _propTypes.default.shape({
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  status: _propTypes.default.oneOf(['success', 'restart', 'loading']).isRequired,
  name: _propTypes.default.string.isRequired,
  progress: _propTypes.default.number
});

exports.uploadPropType = uploadPropType;
Item.propTypes = {
  // eslint-disable-next-line react/no-typos
  upload: uploadPropType.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var _default = Item;
exports.default = _default;